export const quantityTypeSymbols = {
    // MASS      // SI = 1Kg
    // LENGTH    // SI = 1m
    // AREA      // SI = 1m2
    // VOLUME    // SI = 1m3
    MASS: [{value: 1,symbol:"Kg", symbolTitle: "kilogramme"}, {value: 1000,symbol:"T",symbolTitle: "tonne"}],
    LENGTH: [{value: 1,symbol:"m",symbolTitle: "mètre"}, {value: 1000,symbol:"km",symbolTitle:"kilomètre"}],
    AREA: [{value: 1,symbol:"m2"}, {value: 10000,symbol:"ha"}, {value: 1000000,symbol:"km2"}],
    VOLUME: [{value: 1,symbol:"m3"}, {value: 1000000000,symbol:"km3"}]
}

export const quantityTypes = [
    { value: "QUANTITY", text: 'Quantité' },
    { value: "MASS", text: 'Masse' },
    { value: "LENGTH", text: 'Longueur' },
    { value: "AREA", text: 'Surface' },
    { value: "VOLUME", text: 'Volume' }
]

function getBestSymbol(product, productQuantity) {
    if (!product) {
        debugger
        return {
            value: productQuantity,
            symbol:"XXXX",
            symbolTitle: "XXXX",
            text: "XXXX"
        }
    }
    if (product.quantityType === "QUANTITY") {
        return {
            value: productQuantity,
            symbol: product.quantityName,
            symbolTitle: product.quantityName,
            text: productQuantity.toString() + " " + (product.quantityName || (productQuantity > 1 ? "unités" : "unité"))
        }
    }
    //
    // search best symbol
    //
    const symbols = quantityTypeSymbols[product.quantityType]
    if (symbols?.length) {
        let minDiff = 1.e20
        let bestSymbol
        for (const symbol of symbols) {
            const diff = Math.abs(symbol.value - productQuantity)
            if (diff < minDiff) {
                bestSymbol = symbol
                minDiff = diff
            }
        }
        const value = productQuantity / bestSymbol.value
        return {
            value,
            symbol: bestSymbol.symbol,
            symbolValue: bestSymbol.value,
            symbolTitle: bestSymbol.symbolTitle,
            text: value.toString() + " " + bestSymbol.symbol
        }
    }

    debugger
    return {
        value: productQuantity,
        symbol:"XXX",
        symbolTitle: "XXXX",
        text: productQuantity.toString() + " " + "XXXX"
    }
}

export function getSymbolData(product, inQuantity:number = 1) {
    return getBestSymbol(product, (product?.unitQuantity || 1) * inQuantity)
}

export function getProductQuantityText(product, productQuantity) {
    const bestSymbol = getBestSymbol(product, productQuantity)
    return bestSymbol.text

}
